export const ROLE_BROWSER_MIRADOR = 'browser-mirador';

export const BROWSER_MIRADOR_ROLES = [ROLE_BROWSER_MIRADOR];
